module.exports = __webpack_public_path__ + "5a4ad40562be3b48ada69e1cc319f1b2.pdf";